export default {
  sm: `
  데이터센터에 저장되는 방대한 자료는
  미래 기술의 밑거름이 되고 새로운 혁신과
  무한한 경제적 가치 창출의 원천입니다.
  `,
  lg: `
  데이터센터에 저장되는 방대한 자료는 미래 기술의
  밑거름이 되고 새로운 혁신과 무한한
  경제적 가치 창출의 원천입니다. 
  `,
  xxl: `
  데이터센터에 저장되는 방대한 자료는 미래 기술의 밑거름이 되고
  새로운 혁신과 무한한 경제적 가치 창출의 원천입니다.
  `
};
